import { observer } from 'mobx-react-lite'
import { CalendarDropdown, Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useKeywordDetailsContext } from 'pages/keywords/context'
import styles from './styles.module.scss'

export const KeywordStatisticsSearch = observer(() => {
  const { setSearch, search, calendarFilterStore } = useKeywordDetailsContext()

  return (
    <div className={styles.searchWrap}>
      <div className={styles.search}>
        <Icon icon='search' fontSize={20} padding={6} color='var(--content-primary-tertiary)' />
        <TextField
          variant='integrated'
          InputProps={{
            placeholder: 'Search...',
          }}
          onChange={setSearch}
          value={search || ''}
          ariaLabel='StatisticSearch'
        />
      </div>
      <CalendarDropdown store={calendarFilterStore} />
    </div>
  )
})
